import moment from 'moment'

export function initFilter (val, pack) {
  if (val === undefined || val === null) {
    return pack
  } else {
    return val
  }
}

/**
 * @param standard：日期格式，如：HH:mm:ss
 */
export function dateFilter (val, standard) {
  const timeNum = Number(val)
  return moment(timeNum).format(standard)
}

/**
 * @fnName strEncrypt 将字符串中间的若干个字符变成 ***
 * @param str
 */
export function strEncrypt (str, num = 4, mark = '*') {
  if (!str) return ''
  if (typeof str !== 'string') {
    str = str.toString()
  }
  let len = str.length
  // 算出左右两边的剩余字符
  let distance = len - num
  let [l, r] = [0, 0]
  if (distance % 2 === 0) { // 能整除表示可以平衡匹配
    l = r = (distance / 2)
  } else { // 不能整除表示不可以平衡匹配
    l = Math.floor(distance / 2)
    r = l + 1
  }
  let reg = new RegExp(`(?<=^.{${l}}).{${num}}(?=.{${r}}$)`, 'g')
  return str.replace(reg, new Array(num).fill(mark).join(''))
}

export function strNum ([value, length]) {
  if (!value) return
  if (value.length > length) {
    return value.slice(0, length) + '...'
  } else {
    return value
  }
}

export function mentionCurrencyStatus (v) {
  switch (v) {
    case 1:
      return '成功'
    case 0:
      return '审核中'
    case 2:
      return '失败'
    case 3:
      return '等待放币'
    default:
      return ''
  }
}

export function marketFilter (market) {
  if (market === '--') return market
  return market.replace('_', '/').toUpperCase()
}
